import { Component, Input, Output, EventEmitter, ChangeDetectionStrategy } from '@angular/core';
import { SettingsService } from 'services/settings.service';
import { TranslatedString } from 'models/translated-string';
import { weekdayInitialsMondayFirst } from 'util/formatting';

@Component({
  selector: 'cs-date-button-bar',
  templateUrl: 'cs-date-button-bar.html',
  host: { 'class': 'date-button-bar' },
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CsDateButtonBar {
  @Input() selectedDays: boolean[] = []; // Array of 7 booleans, ISO weekday order (Mon=0, Sun=6)
  @Output() selectedDaysChange = new EventEmitter<boolean[]>();

  // ISO weekday order: Mon, Tue, Wed, Thu, Fri, Sat, Sun
  readonly dayLabels: TranslatedString[] = weekdayInitialsMondayFirst();

  constructor(private settings: SettingsService) {}

  get displayOrder(): number[] {
    return this.settings.getWeekDayDisplayOrder();
  }

  toggleDay(isoIndex: number) {
    const newSelectedDays = [...this.selectedDays];
    newSelectedDays[isoIndex] = !newSelectedDays[isoIndex];
    this.selectedDaysChange.emit(newSelectedDays);
  }
}
